import { makeStyles } from "@material-ui/core";
import * as React from "react";
import { cloneElement } from "react";
import { sanitizeListRestProps, TopToolbar, useListContext } from "react-admin";

const useStyles = makeStyles((theme) => ({
	button: {
		"& .MuiButton-label": {
			alignItems: "start",
			"& span": {
				whiteSpace: "nowrap",
			},
		},
	},
}));

const Actions = ({ permissions, ...props }) => {
	const classes = useStyles();
	const { className, exporter, filters, maxResults, ...rest } = props;
	const {
		resource,
		displayedFilters,
		filterValues,
		showFilter,
	} = useListContext();
	return (
		<TopToolbar className={className} {...sanitizeListRestProps(rest)}>
			{filters &&
				cloneElement(filters, {
					resource,
					showFilter,
					displayedFilters,
					filterValues,
					context: "button",
					className: classes.button,
				})}
		</TopToolbar>
	);
};

export default Actions;
